{
  "search_users": "Hae käyttäjiä...",
  "no_users_found": "Käyttäjiä ei löytynyt",
  "users_table": {
    "user": "Käyttäjä",
    "name": "Nimi",
    "email": "Sähköposti",
    "role": "Rooli",
    "tenant": "Seura",
    "created": "Luotu",
    "icons": {
      "course_conditions": "Käyttäjällä on kierroksia, joihin on tallennettu kentän olosuhteet",
      "friends": "Käyttäjällä on kavereita",
      "statistics": "Käyttäjällä on kierroksia, joihin on tallennettu tilastoja"
    }
  },
  "create_user": "Luo käyttäjä",
  "create_user_page": {
    "title": "Luo uusi käyttäjä",
    "section_account": "Tilitiedot",
    "section_personal": "Henkilötiedot",
    "section_golf": "Golftiedot",
    "username": "Käyttäjätunnus",
    "email": "Sähköposti",
    "password": "Salasana",
    "first_name": "Etunimi",
    "last_name": "Sukunimi",
    "gender": "Sukupuoli",
    "date_of_birth": "Syntymäpäivä",
    "handicap_index": "Tasoitus",
    "role": "Rooli",
    "tenant": "Asiakas",
    "no_tenant": "Ei asiakasta",
    "submit": "Luo käyttäjä",
    "success": "Käyttäjä luotu onnistuneesti",
    "error": "Käyttäjän luominen epäonnistui",
    "password_requirements": "Vähintään 8 merkkiä, iso ja pieni kirjain sekä numero",
    "email_taken": "Sähköpostiosoite on jo käytössä",
    "email_required": "Sähköposti on pakollinen",
    "email_invalid": "Virheellinen sähköpostiosoite",
    "first_name_required": "Etunimi on pakollinen",
    "last_name_required": "Sukunimi on pakollinen"
  },
  "edit_user_page": {
    "save": "Tallenna",
    "delete": "Poista",
    "delete_confirm_title": "Poista käyttäjä",
    "delete_confirm_message": "Haluatko varmasti poistaa käyttäjän {{name}}?",
    "password_hint": "Jätä tyhjäksi jos et halua vaihtaa",
    "email_hint": "Vaihto astuu voimaan heti ilman vahvistusviestiä",
    "registration_method": "Rekisteröitymistapa",
    "registration_time": "Rekisteröitymisaika",
    "success": "Käyttäjä päivitetty",
    "deleted": "Käyttäjä poistettu",
    "not_found": "Käyttäjää ei löytynyt",
    "refresh_handicap": "Päivitä eBirdiestä",
    "refresh_handicap_updated": "Tasoitus päivitetty: {{value}}",
    "refresh_handicap_unchanged": "Tasoitus on jo ajan tasalla",
    "refresh_handicap_null": "eBirdiestä ei saatu tasoitusta",
    "refresh_handicap_failed": "Tasoituksen haku eBirdiestä epäonnistui",
    "refresh_handicap_not_linked": "Käyttäjällä ei ole linkitettyä SuomiGolf-tunnusta",
    "section_account": "Tilitiedot",
    "section_personal": "Henkilötiedot",
    "section_golf": "Rooli",
    "registered": "Rekisteröity",
    "time": "Aika",
    "ebirdie_linked": "eBirdie linkitetty",
    "hcp": "HCP",
    "customer": "Asiakas (seura)",
    "tabs": {
      "basic": "Perustiedot",
      "rounds": "Pelatut kierrokset"
    },
    "results_table": {
      "title": "Pelatut kierrokset",
      "when": "Pelattu",
      "where": "Kenttä",
      "tee": "Tee",
      "type": "Tyyppi",
      "status": "Tila",
      "ebirdie_status": "eBirdie",
      "resend": "Lähetä uudelleen",
      "resend_success": "Lähetys käynnistetty uudelleen",
      "resend_failed": "Uudelleenlähetys epäonnistui",
      "confirm_resend_title": "Lähetä eBirdielle uudelleen",
      "confirm_resend_body": "Lähetetäänkö {{date}} pelattu kierros kentällä {{course}} eBirdielle uudelleen?",
      "no_results": "Ei pelattuja kierroksia",
      "type_competition": "Kilpailukierros",
      "type_handicap": "Tasoituskierros",
      "type_round": "Harjoituskierros",
      "status_completed": "Valmis",
      "status_in_progress": "Käynnissä",
      "status_abandoned": "Keskeytetty",
      "status_disqualified": "Hylätty",
      "ebirdie_status_completed": "Lähetetty",
      "ebirdie_status_queued": "Jonossa",
      "ebirdie_status_failed": "Virhe",
      "ebirdie_status_permanent_failure": "Lopullinen virhe"
    }
  },
  "users_page": {
    "refresh_all_handicaps": "Päivitä tasoitukset",
    "refresh_all_summary": "Päivitetty {{updated}}/{{scanned}} (ennallaan {{unchanged}}, tyhjä {{nullFromEbirdie}}, virhe {{failed}})"
  },
  "handicap_recommendations": {
    "title": "Tasoitussuositukset",
    "add_new": "Lisää uusi",
    "edit": "Muokkaa suositusta",
    "all_types": "Kaikki pelityypit",
    "percentages_help": "Syötä prosentit pilkulla erotettuna, esim. 30,20,10",
    "table": {
      "play_type": "Pelimuoto",
      "team_size": "Joukkuekoko",
      "counting_scores": "Laskettavia tuloksia",
      "handicap_factor": "Tasoituskerroin",
      "team_percentages": "Joukkueen tasoitusprosentit",
      "description": "Kuvaus",
      "source": "Lähde",
      "status": "Tila",
      "men_max": "Miehet max",
      "women_max": "Naiset max"
    },
    "no_recommendations": "Ei tasoitussuosituksia."
  }
}
